import cx from 'classnames';
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { CSSProperties, ReactNode } from 'react';

import styles from './popup.module.scss';
import { PopupTheme } from './types';

export interface PopupProps {
  theme?: PopupTheme;
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  withArrow?: boolean;
  style?: CSSProperties;
}

const Popup = ({ theme = 'dark', isOpen, children, className, withArrow = false, style }: PopupProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <m.div
          className={cx(styles.wrapper, className, { [styles.arrow]: withArrow })}
          style={{ pointerEvents: isOpen ? 'auto' : 'none', ...style }}
          initial={{
            clipPath: 'inset(0% 0% 100% 0% round 4px)',
            opacity: 0,
          }}
          animate={{
            clipPath: 'inset(-1% -1% -1% -1% round 0px)',
            opacity: 1,
          }}
          exit={{
            clipPath: 'inset(0% 0% 100% 0% round 4px)',
            opacity: 0,
          }}
          transition={{
            type: 'spring',
            bounce: 0,
            duration: 0.3,
          }}
        >
          <div className={cx(styles.popup, styles[theme])}>{children}</div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default Popup;
